import './device-main-card.styles.css';
import Logo from "../../assets/images/logo.png";

const DeviceMainCard = ({ cat }) => {
  return (
    <div className="device-card">
      <div className="device-top-icons-wrapper">
        {cat.map((item) => (
          <img
            key={item.id}
            className={`device-item-icon ${item.state === "true" ? "stable-item" : ""}`}
            src={item.miniIcon}
            alt={item.title}
          />
        ))}
      </div>
      <div className="card-log-wrapper">
        <img src={Logo} alt="Logo" className="device-logo" />
        <p className="logo-text">{process.env.REACT_APP_DEVICE_ID}
        </p>
      </div>
    </div>
  );
};

export default DeviceMainCard;
